export type C100Timeframe = '1D' | '3D' | '1M' | '6M' | 'YTD' | '1Y' | '5Y'

export const C100_TIMEFRAMES: C100Timeframe[] = [
  '1D',
  '3D',
  '1M'
  // Temporarily disabled — re-enable when ready:
  // '6M',
  // 'YTD',
  // '1Y',
  // '5Y'
]

export interface C100Mover {
  ticker: string
  name: string
  pct: number
}

export interface C100Banner {
  nameCount: number
  sectorCount: number
  avgMovePct: number
  lead: C100Mover | null
  laggard: C100Mover | null
}

export type ObOsState = 'OB' | 'OS' | 'N'

// Screen signals frozen at publish. All nullable — 0 is a real score, so a
// missing value arrives as null and renders as an em dash, never a fake zero.
export interface C100Signals {
  score: number | null // composite 0-100
  screenCount: number // how many screens the name hit; 1 shows no chip
  marketCap: number | null
  tech: number | null // Technical
  fund: number | null // Fundamental
  mom: number | null // Momentum
  obOs: { st: ObOsState; it: ObOsState; lt: ObOsState } | null
  upStreakDays: number | null // consecutive up days
  trendLabel: string | null // e.g. 'Established Uptrend'
  analyst: { rating: string; grade: string | null } | null // null when 'N/A'
}

export interface C100Row extends C100Signals {
  ticker: string
  rank: number
  rankDelta: number | null // vs previous version; positive = climbed, null = new/first list
  isNew: boolean
  name: string
  sector: string
  industry: string
  market: string
  price: number
  dayChangePct: number
  timeframeChangePct: number | null
  trend: 'up' | 'down' | 'flat' // sparkline direction — distinct from trendLabel
  sparkline: number[]
}

export interface C100Payload {
  version: number
  updatedAt: string
  timeframe: C100Timeframe
  banner: C100Banner
  rows: C100Row[]
}
